import {
	App,
	deserializeNotifications,
	ENVIRONMENT,
	HttpsParamsBuilderNew,
	MetaNew,
	Notification,
} from '@agilox/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NotificationsService {
	private readonly http = inject(HttpClient);
	private readonly environment = inject(ENVIRONMENT);

	getNotifications(
		app: App | undefined,
		number: number,
		size: number,
		sort: string,
		relevant = false
	): Observable<{ notifications: Notification[]; meta: MetaNew }> {
		const filter: Record<string, string | boolean> = {};
		if (app) {
			filter['~app'] = app;
		}
		if (relevant) {
			filter['~relevant'] = true;
		}

		const params = HttpsParamsBuilderNew.buildParameters({
			pageNumber: number,
			pageSize: size,
			sort,
			filter: filter ?? undefined,
		});
		return this.http
			.get<any>(this.environment.serverNew + '/user/v1/notifications', { params })
			.pipe(switchMap((doc) => deserializeNotifications(doc)));
	}
}
